import React from 'react';
import { Text } from 'core/components';
import { LookupId } from 'app/util/lookups/createLookup';
import { useDeviceLookup } from 'app/util/lookups/deviceIndex';

// sized by its text, so the skeleton matches the surrounding font and line height
const LOADING_PLACEHOLDER = <Text showSkeleton>device-name</Text>;

interface DeviceNameProps {
  deviceId: LookupId;
  // shown while loading (instead of a skeleton), and when the device doesn't exist or isn't visible (e.g. a possibly
  // stale name); defaults to the id
  fallbackLabel?: string;
}

const DeviceName = ({ deviceId, fallbackLabel }: DeviceNameProps) => {
  const { data: device, isLoading } = useDeviceLookup(deviceId);

  if (isLoading) {
    return <>{fallbackLabel || LOADING_PLACEHOLDER}</>;
  }

  return <>{device?.device_name || fallbackLabel || String(deviceId ?? '')}</>;
};

export default DeviceName;
